import React from "react";
import { Grid, Checkbox, Text, Title, Divider } from "@mantine/core";
import "./CheckListDesktopView.scss";
import jpgIcon from "../../../assets/jpg_icon.png";

interface CheckListDesktopViewProps {
  documents: any[];
  totalDocuments: number;
  showTitle?: boolean;
  responses: any;
  hasSpouseDocs: boolean;
}

interface DocumentContentProps {
  doc: any;
  responses: any;
}

const DocumentContent: React.FC<DocumentContentProps> = ({
  doc,
  responses,
}) => (
  <>
    <img className="document-icon" src={jpgIcon} alt="Document icon" />
    <div className="document-details">
      <div className="document-title">
        {doc.title}
        {doc.count > 1 && (
          <p className="document-count-badge">
            {`${responses?.uploadedDocs?.[doc.type]?.length ?? 0} of ${doc.count}`}
          </p>
        )}
      </div>
      <Text size="sm" c="dimmed">
        {doc.description}
      </Text>
    </div>
  </>
);

const CheckListDesktopView: React.FC<CheckListDesktopViewProps> = ({
  documents,
  totalDocuments,
  showTitle,
  responses,
  hasSpouseDocs,
}) => {
  return (
    <Grid>
      <Grid.Col span={12}>
        {showTitle && (
          <>
            <span className="count-container">
              <Title order={3}>Documents</Title>
              <h2 className="document-count">{totalDocuments}</h2>
            </span>
            <Text className="document-description">
              Based on your selections, you will need the following documents to
              file your taxes:
            </Text>
          </>
        )}
        <div
          className="document-list"
          style={{ marginTop: showTitle ? "0" : "1rem" }}
        >
          {hasSpouseDocs ? (
            ["My", "My Spouse's"].map((section, index) => (
              <React.Fragment key={section}>
                {index > 0 && (
                  <Divider className="divider" size="sm" color="#D9D9D9" />
                )}
                <div
                  className={`${section.toLowerCase().replace("'s", "")}-documents`}
                >
                  <h3 className="section-title">{section} Documents</h3>
                  {documents
                    .filter((doc) =>
                      section === "My"
                        ? !doc.type.includes("spouse")
                        : doc.type.includes("spouse")
                    )
                    .map((doc) => (
                      <div className="document-item" key={doc.type}>
                        <Checkbox
                          size="md"
                          radius="lg"
                          checked={
                            responses?.uploadedDocs?.[doc.type]?.length >=
                            doc.count
                          }
                          color="#0077CC"
                          readOnly
                        />
                        <DocumentContent doc={doc} responses={responses} />
                      </div>
                    ))}
                </div>
              </React.Fragment>
            ))
          ) : (
            <div className="my-documents">
              {documents.map((doc) => (
                <div className="document-item" key={doc.type}>
                  <Checkbox
                    size="md"
                    radius="lg"
                    checked={
                      responses?.uploadedDocs?.[doc.type]?.length >= doc.count
                    }
                    color="#0077CC"
                    readOnly
                  />
                  <DocumentContent doc={doc} responses={responses} />
                </div>
              ))}
            </div>
          )}
        </div>
      </Grid.Col>
    </Grid>
  );
};

export default CheckListDesktopView;
